import React, { Fragment } from 'react';
import { useAsync } from '@tiger/hooks';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';
import withI18n, { I18nProps } from 'utils/i18n/withI18n';
import { CurrentUser } from 'types/UserStatus';

import store from '../../../store';

import QuestionItem from './Item';

const Question: React.FC<I18nProps & { currentUser: CurrentUser }> = ({ i18n: { language, __ }, currentUser }) => {
    const [state, getData] = useAsync(() => store.getQuestion(language, currentUser));

    function render() {
        if (state.loading) {
            return <Loading tip={__('loading...')} />;
        }

        if (state.error) {
            return <ErrorBox error={state.error} onClick={getData} />;
        }

        if (!state.data.data.items.length) {
            return null;
        }

        return (
            <Fragment>
                <h2>{__('Common FAQs')}</h2>
                {state.data.data.items.map(item => {
                    return <QuestionItem key={item.id} data={item} />;
                })}
            </Fragment>
        );
    }

    return <div className="question">{render()}</div>;
};

export default withI18n(Question);
